import { render, staticRenderFns } from "./CustomFooter.vue?vue&type=template&id=6e72b587&"
import script from "./CustomFooter.vue?vue&type=script&lang=js&"
export * from "./CustomFooter.vue?vue&type=script&lang=js&"
import style0 from "./CustomFooter.vue?vue&type=style&index=0&id=6e72b587&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports